import { useTranslation } from 'react-i18next';
import { Info, Building2 } from 'lucide-react';

import { ActionButton } from '@/shared/ui/action-button';
import { SimpleSelect } from '@/shared/ui/filters';
import { FormField } from '@/shared/ui';
import type { SelectOption } from '@/shared/ui';

interface OrganizationSelectProps {
  label: string;
  organizationId?: string;
  options: SelectOption[];
  isLoading: boolean;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  /** Query the field starts with, e.g. the organization name an SRF import could not resolve. */
  initialQuery?: string;
  onChange: (id: string | undefined) => void;
  handleOrgOpen: () => void;
}

export const OrganizationSelect = ({
  label,
  organizationId,
  options,
  isLoading,
  disabled = false,
  required = false,
  error,
  initialQuery,
  onChange,
  handleOrgOpen
}: OrganizationSelectProps) => {
  const { t } = useTranslation();

  return (
    <FormField label={label} name="organization" required={required} error={error}>
      <div className="flex gap-2">
        <SimpleSelect
          options={options}
          value={organizationId}
          onChange={onChange}
          isLoading={isLoading}
          placeholder={t('common.selectOrganization')}
          initialQuery={initialQuery}
          className="flex-1"
          disabled={disabled}
        />

        {organizationId && (
          <ActionButton
            type="button"
            intent={disabled ? 'view' : 'action'}
            size="icon"
            onClick={handleOrgOpen}
            className="w-11"
            title={disabled ? t('organizations.viewDetails') : t('organizations.editOrganization')}>
            {disabled ? <Info className="w-4 h-4" /> : <Building2 className="w-4 h-4" />}
          </ActionButton>
        )}
      </div>
    </FormField>
  );
};
